import React from "react";
import styled from "styled-components";
import { Image } from "react-bootstrap";
import { ICustomer } from "../../interfaces/customer";
import { IPets } from "../../interfaces/pets";

const Container = styled.section`
  display: flex;
  flex: 1;
  flex-direction: column;
  font-family: "Prompt";
  align-items: center;
  justify-content: center;
  margin: auto 0;
`;

const TextDescriptionContainer = styled.div`
  text-align: center;
  margin-top: 0.5rem;
`;
const ProfileName = styled.p`
  font-size: 32px;
  color: #123559;
  font-weight: bold;
  margin: 0;
`;

const CaseIdContainer = styled.p`
  font-size: 18px;
  color: rgba(18, 53, 89, 0.7);
  font-weight: 400;
  margin: 0;
`;

const PetNameContainer = styled.p`
  font-size: 18px;
  line-height: 2rem;
  color: #c4c4c4;
  font-weight: 400;
  margin: 0;
`;

const PetSpan = styled.span`
  font-size: 18px;
  color: #123559;
  font-weight: 400;
  margin: 0;
`;

const PetSymptomContainer = styled.article`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 0.25rem;
  width: calc(100% - 2rem);
`;

const PetSymptomHeader = styled(PetNameContainer)`
  line-height: 1.5rem;
  overflow-wrap: break-word;
`;

const PetSymptomText = styled.p`
  font-size: 16px;
  color: #123559;
  font-weight: 400;
  margin: 0;
  overflow-wrap: break-word;
`;

const HistoryContainer = styled.section`
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  margin-top: 0.25rem;
  width: 100%;
`;

const HistoryAppointmentContainer = styled.div`
  text-align: center;
  width: 50%;
`;
const TextInHistory = styled.p`
  font-size: ${(props: { size: string; package?: boolean }) => props.size};
  color: #000000;
  margin: 0;
  line-height: ${(props: { size: string; package?: boolean }) =>
    props.package ? "60px" : "1.5em"};
`;
const Button = styled.button`
  background-color: #0dd07e;
  color: #fff;
  border-radius: 20px;
  margin: 1rem 0rem;
  padding: 0.5rem 3rem;
  border: 3px solid #0dd07e;

  &:hover {
    background-color: #fff;
    color: #000;
  }
`;

const ImageProfile = styled(Image)`
  border: 4px solid #123559;
  margin-top: 0.5rem;
`;

const CustomerCard = (props: {
  dataCustomer: ICustomer;
  ToggleShow: () => void;
  onClickShowPets: (pets: IPets[]) => void;
}) => {
  const data = props.dataCustomer;
  const petAmount = props.dataCustomer.pets?.length;
  const record = props.dataCustomer.history?.length;
  const pet = props.dataCustomer.pets?.find(
    (pet) => pet.pid === props.dataCustomer.pid
  );

  const onClickShowPets = props.onClickShowPets;
  return (
    <Container>
      <ImageProfile
        src={data.imageUrl}
        width={120}
        height={120}
        roundedCircle
      />
      <TextDescriptionContainer>
        <ProfileName>{data.displayName}</ProfileName>
        <CaseIdContainer>Case ID : {data.bookingId}</CaseIdContainer>
        <PetNameContainer>
          ชื่อสัตว์เลี้ยง : <PetSpan>{pet?.petName}</PetSpan>
          &nbsp;&nbsp;ประเภท : <PetSpan>{pet?.petType}</PetSpan>
        </PetNameContainer>
      </TextDescriptionContainer>
      <PetSymptomContainer>
        <PetSymptomHeader>ลักษณะอาการเบื้องต้น :</PetSymptomHeader>
        <PetSymptomText>{data.descriptions}</PetSymptomText>
      </PetSymptomContainer>
      <PetSymptomContainer>
        <PetSymptomHeader>แพคเกจที่เลือกใช้ :</PetSymptomHeader>
        <PetSymptomText>
          {data?.product?.productName} ({data?.product?.type})
        </PetSymptomText>
      </PetSymptomContainer>
      {data?.product && (
        <PetSymptomContainer>
          <PetSymptomHeader>ระยะเวลาดูแล :</PetSymptomHeader>
          <PetSymptomText>{`${
            data.product.type === "chat"
              ? data.product.timeRange && data.product.timeRange / 1440 + " วัน"
              : data.product.timeRange + " นาที"
          }`}</PetSymptomText>
        </PetSymptomContainer>
      )}
      <HistoryContainer>
        <HistoryAppointmentContainer>
          <TextInHistory size="18px">ประวัติการใช้บริการ</TextInHistory>
          <TextInHistory size="40px">{record}</TextInHistory>
        </HistoryAppointmentContainer>
        {/* <HistoryAppointmentContainer>
          <TextInHistory size="28px" package>
            {data.product.type}
          </TextInHistory>
          <TextInHistory size="18px">
            แพคเกจ <br /> ที่เลือกใช้
          </TextInHistory>
        </HistoryAppointmentContainer> */}
        <HistoryAppointmentContainer
          style={{ cursor: "pointer" }}
          onClick={() => onClickShowPets(data.pets || [])}
        >
          <TextInHistory size="18px">จำนวนสัตว์เลี้ยง</TextInHistory>
          <TextInHistory size="40px">{petAmount}</TextInHistory>
        </HistoryAppointmentContainer>
      </HistoryContainer>
      <Button onClick={props.ToggleShow}>ตอบรับคำขอ</Button>
    </Container>
  );
};

export default CustomerCard;
